import { useRef } from 'react';

/**
 * A simple hook that tracks which fields have been explicitly selected by the user
 * to prevent them from being overwritten by automatic selections.
 */
export function useAutoSelectionTracker() {
  // Track which fields have been explicitly selected by the user
  const userSelectedFields = useRef<Set<string>>(new Set());
  
  // Mark a field as explicitly selected by the user
  const markAsUserSelected = (fieldName: string) => {
    userSelectedFields.current.add(fieldName);
  };
  
  // Check if a field has been explicitly selected by the user
  const isUserSelected = (fieldName: string) => {
    return userSelectedFields.current.has(fieldName);
  };
  
  // Clear user selection status for a field
  const clearUserSelected = (fieldName: string) => {
    userSelectedFields.current.delete(fieldName);
  };
  
  return { markAsUserSelected, isUserSelected, clearUserSelected };
}
